export default __webpack_public_path__ + "static/media/32t.2d00b4a6.jpg";